module.exports = flarum.extensions['acpl-mobile-tab'];